<template>
    <svg :class="design" :width="width" :height="height" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="11" cy="11" r="11" fill="#FF6675"/>
        <path d="M12.1899 11L14.8829 8.30704C15.0387 8.15129 15.0387 7.89855 14.8829 7.74255L14.2572 7.11681C14.1014 6.96106 13.8487 6.96106 13.6927 7.11681L10.9999 9.81002L8.30683 7.11706C8.15108 6.96131 7.89833 6.96131 7.74232 7.11706L7.11681 7.74255C6.96106 7.8983 6.96106 8.15104 7.11681 8.30704L9.80986 11L7.11681 13.693C6.96106 13.8487 6.96106 14.1015 7.11681 14.2574L7.74257 14.8832C7.89833 15.0389 8.15108 15.0389 8.30708 14.8832L10.9999 12.19L13.6929 14.8829C13.8487 15.0387 14.1014 15.0387 14.2574 14.8829L14.8832 14.2572C15.0389 14.1015 15.0389 13.8487 14.8832 13.6927L12.1899 11Z" fill="white"/>
    </svg>
</template>
<script>
    export default {
        name: 'ui-close-icon',
        props: {
            design: {
                type: String,
                default: ''
            },
            fill: {
                type: String,
                default: '#FFF'
            },
            width: {
                type: [String, Number],
                default: 22
            },
            height: {
                type: [String, Number],
                default: 22
            }
        }
    }
</script>